/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Range, getTrackBackground } from 'react-range';
import { IFilter, Fields } from 'utils/filtros';
import { useDispatch } from 'react-redux';
import { vagasActions, AppTypes } from 'store/ducks';
import _ from 'lodash';

const STEP = 100;
const MIN = 0;
const MAX = 30000;

const RangePicker = ({ min, max, step }) => {
  const [values, setValues] = useState([MIN, MAX]);
  const dispatch = useDispatch();

  const debouncedRange = _.debounce(val => {
    dispatch(vagasActions.filtarVagas(IFilter.range(Fields.salario, val[0], val[1])));
    dispatch({ type: AppTypes.SET_VAGAS_LOADING_FiNISHED });
  }, 2000);

  const handleChange = val => {
    setValues(val);
    dispatch({ type: AppTypes.SET_VAGAS_LOADING });
    debouncedRange(val);
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
      }}
    >
      <Range
        values={values}
        step={step || STEP}
        min={min || MIN}
        max={max || MAX}
        onChange={handleChange}
        renderTrack={({ props, children }) => (
          // eslint-disable-next-line jsx-a11y/no-static-element-interactions
          <div
            onMouseDown={props.onMouseDown}
            onTouchStart={props.onTouchStart}
            style={{
              ...props.style,
              height: '36px',
              display: 'flex',
              width: '100%',
            }}
          >
            <div
              ref={props.ref}
              style={{
                height: '5px',
                width: '100%',
                borderRadius: '4px',
                background: getTrackBackground({
                  values,
                  colors: ['#ccc', '#548BF4', '#ccc'],
                  min: MIN,
                  max: MAX,
                }),
                alignSelf: 'center',
              }}
            >
              {children}
            </div>
          </div>
        )}
        renderThumb={({ props, isDragged }) => (
          <div
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
            style={{
              ...props.style,
              height: '25px',
              width: '25px',
              borderRadius: '50%',
              backgroundColor: '#FFF',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              boxShadow: '0px 2px 6px #AAA',
            }}
          >
            <div
              style={{
                height: '16px',
                width: '5px',
                backgroundColor: isDragged ? '#548BF4' : '#CCC',
              }}
            />
          </div>
        )}
      />
      <output style={{ marginTop: '0px' }} id="output">
        {`R$ ${values[0].toFixed(2)}`} - {`R$ ${values[1].toFixed(2)}`}
      </output>
    </div>
  );
};

export default RangePicker;
